import { PrivateOfficeLifecycleState } from "@/@types/private-office.types";

export type AmenitiesLocales = "en" | "pt" | "es";

export type PrivateOfficeSubType = "PRIVATE_OFFICE_LEGACY";

export const PRIVATE_OFFICE_SUB_TYPES = {
  LEGACY: "PRIVATE_OFFICE_LEGACY",
} as const satisfies Record<string, PrivateOfficeSubType>;

export type AmenityEntity = {
  id: number;
  name: string;
  locale?: AmenitiesLocales;
  is_automatic_generated: boolean;
  created_at: Date;
  updated_at: string;
  deleted_at?: Date | null;
  category_id: number;
  attributes: PrivateOfficeAttributesEntity[];
  is_internal_amenity: boolean;
};

export type CategoryEntity = {
  id: number;
  name: string;
  description?: string | null;
  created_at: Date;
  updated_at: Date;
  deleted_at?: Date | null;
};

export type PrivateOfficeAttributesEntity = {
  id: number;
  name: string;
  content: string;
  content_type?: string | null;
  register_user?: number | null;
  created_at: Date;
  updated_at: Date;
  deleted_at?: Date | null;
  is_internal_attribute: boolean;
};

export type GroupedAmenities = {
  name: string;
  description?: string | null;
  amenities: AmenityEntity[];
};

export type PrivateOfficeResponse = {
  id: string;
  dpp: string | null;
  space_id: number;
  search_id: number;
  label: string;
  size: number | null;
  capacity: number;
  monthly_price: number;
  yearly_price: number | null;
  guarantee_fee: string | null;
  contract_fine: string | null;
  amenities: string | string[];
  extra_services: string | string[];
  shared_amenities: string | null;
  shared_extra_services: string | null;
  advantages: string | null;
  picture_url: string;
  picture_url1: string | null;
  picture_url2: string | null;
  picture_url3?: string | null | undefined;
  picture_url4?: string | null | undefined;
  picture_url5?: string | null | undefined;
  notes: string;
  is_fulltime: number | null;
  status: number;
  category?: number;
  is_virtual: boolean;
  is_pre_available: boolean;
  company_id: number | null;
  contracted_at: Date | null;
  data_updated_at: Date;
  registrant_user_id?: number | null;
  engagement_level: number;
  available_date?: Date | null;
  created_at: Date;
  updated_at: string;
  deleted_at?: Date | null;
  credits: number;
  pictures: string[];
  grouped_amenities: GroupedAmenities[];
  source?: string;
  origin?: string;
  sub_type?: PrivateOfficeSubType | null;
  external_url?: string;
  lifecycle_state?: PrivateOfficeLifecycleState | null;
  availability_date?: string | null;
};

export type PrivateRoomData = {
  private_office: PrivateOfficeResponse;
};

export type GetPrivateRoomsResponseApi = {
  data: PrivateRoomData;
};
